/* eslint-disable */
export default function fontSizeSwitcher() {
  const switchersContainer = document.querySelector('.font-size-switcher');

  if (!switchersContainer) return;
  const mediaQuery = window.matchMedia('(max-width: 1023px)');
  const root = document.documentElement;

  switchersContainer.addEventListener('change', (e) => {
    if (e.target.value === 'increased') {
      const newFontSize = e.target.getAttribute('data-font-size');
      root.style.fontSize = (newFontSize !== null && newFontSize.length ? newFontSize : '22') + 'px';
    } else if (e.target.value === 'default') {
      root.style.fontSize = '';
    }
  });

  function resizeHandler(e) {
    if (e.matches) {
      const defaultSwitcher = switchersContainer.querySelector('[value="default"]');
      if (!defaultSwitcher.checked) {
        defaultSwitcher.checked = true;
        root.style.fontSize = '';
      }
    }
  }

  resizeHandler(mediaQuery);
  mediaQuery.addEventListener('change', resizeHandler);
}
